export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const money = (n) => `₹${Number(n ?? 0).toLocaleString("en-IN")}`;

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
  else el.scrollIntoView({ behavior: "smooth" });
};
